<div class="grid">
  <div class="col-12">
    <div class="col-12">
      <div class="col-2">{{ 'UPLOAD_COMPONENT.SPOOL_NAME' | translate }}</div>
      <div class="col-3">
        <input type="text" pInputText (keyup)="checkNameValidity()"
             [(ngModel)]="name" [ngClass]="{'not-valid': !validSpoolName, 'valid': validSpoolName}">
      </div>
      <div class="col-7">
        <button pButton type="button" [icon]="'fa fa-upload'" class="p-button-success" style="float: right;"
                [label]="'COMMON.VALIDATE' | translate"
                [disabled]="!uploadIsPossible()" (click)="createSpool()"></button>
      </div>
  </div>

  <div class="col-12">
    <div class="col-2">{{ 'UPLOAD_COMPONENT.SPOOL_FILE_NAME' | translate }}</div>
    <div class="col-3">
      <input type="text" pInputText (keyup)="checkFileNameValidity()"
             [(ngModel)]="fileName" [ngClass]="{'not-valid': !validSpoolFileName, 'valid': validSpoolFileName}">
    </div>
    <div class="col-7">{{ 'UPLOAD_COMPONENT.SPOOL_FILE_NAME_HINT' | translate }}</div>
  </div>


  <div class="col-12">
    <h4>{{ 'UPLOAD_COMPONENT.SPOOL_FILE' | translate }}</h4>
  </div>
  <div class="col-12">
    <p-fileUpload #fileUpload
      [chooseLabel]="'COMMON.BROWSE' | translate"
      [cancelLabel]="'COMMON.CANCEL' | translate"
      [multiple]="false"
      [showUploadButton]="false"
      [accept]="acceptedFiles"
      [customUpload]="true"
      (onClear)="clearFiles()"></p-fileUpload>
  </div>
</div>
<div class="grid">

</div>
